import { Accordion, AccordionItem, AccordionButton, AccordionPanel } from "@chakra-ui/react";
import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import { Box, chakra } from "@chakra-ui/react";

export const ParentAccordion = () => {
  return (
    <Accordion allowMultiple>
      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF">
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  Why are you called AdmitYogi?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              The word “yogi” is tangential to the word “guru.” While a guru teaches how to lead a
              life of serenity, an AdmitYogi practices it. At AdmitYogi, we show how to succeed in
              college applications, but by example.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  What do you do?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              AdmitYogi is a platform that provides valuable resources and tools to assist high
              school students and parents in navigating the college admissions process. We offer
              AdmitYogi Profiles - a catalog of thousands of successful college applications;
              AdmitYogi Essays - an AI-powered admissions essay revision tool, and AdmitYogi
              ChanceMe - an acceptance rate calculator to help students succeed in their college
              applications.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  Who created AdmitYogi?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              AdmitYogi was created by several students at Stanford University. We wish a resource
              like this existed when we were in high school!
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  Why was AdmitYogi created?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              AdmitYogi was created to address the complexities and challenges of the college
              admissions process. Our mission is to empower students and parents by providing access
              to valuable information, guidance, and tools that can improve their chances of
              admission to their desired colleges and do it in an extremely affordable, inclusive
              way.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  Why should I use this service?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              Getting into college is more difficult than ever before. In 2022 alone, acceptance
              rates at some selective schools have halved. In a period where students must do
              everything possible to stand out, viewing successful profiles and understanding what
              admissions officers like and don't like is invaluable. Moreover, our AI-driven essay
              revision tool and a sophisticated acceptance rate calculator have proven to be helpful
              to thousands of happy students and families who went through this journey.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  How can my child benefit from AdmitYogi profiles?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              AdmitYogi profiles showcase successful college applications, including essays,
              academics, extracurriculars, and admissions advice. When unlocked, they can provide
              valuable insights and inspiration for your child's own application.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  How does Admit Yogi Essay revision work, and how can it help my child?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              The Admit Yogi Essay tool uses admissions rubrics and counselor methodologies to
              evaluate essays, provide feedback, and offer detailed recommendations quickly and at
              an affordable cost. It helps your child improve their college application essay
              quickly and effectively.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  What is the acceptance rate calculator, and how accurate is it in predicting my
                  child's chances of getting into their preferred schools?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              The acceptance rate calculator uses AI and over 6,000 data points to calculate a
              student's chances of admission at specific schools. It also analyses the gaps in the
              profile and gives a recommendation on how to strengthen you child’s candidacy.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  I have a question that isn't answered here. How can I contact you?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              If you have any additional questions or need further assistance, you can contact our
              customer support team through the{" "}
              <a href="/contact-us" style={{ textDecoration: "underline" }}>
                Contact Us
              </a>{" "}
              section on our website. We are here to help and provide personalized support for your
              specific needs.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  How much does AdmitYogi cost for parents and students?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              AdmitYogi offers various pricing options for its products. You can find detailed
              pricing information on the{" "}
              <a href="/plans" style={{ textDecoration: "underline" }}>
                Packages page
              </a>{" "}
              on the website.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>
    </Accordion>
  );
};
